import { lazyLoad } from '@/lib/LazyLoad';

export const SlackDetailPage = lazyLoad(
  () => import('./SlackDetailPage'),
  (module) => module.SlackDetailPage
);
